export class PleasedError extends Error {
  constructor(
    public code: string,
    public message: string = '',
    protected noEmit = false
  ) {
    super(message);
  }

  static FIREBASE_APP_INIT_NO_CONFIG = 'FIREBASE_APP_INIT_NO_CONFIG';
  static FIREBASE_SEND_MESSAGE_FAILED = 'FIREBASE_SEND_MESSAGE_REJECT';
}
export class PleasedInternalError extends PleasedError {
  protected noEmit = true;
}
